
// import { Card, CardContent } from "@/components/ui/card";
import { Topbar } from "./misc/topbar";
// import TaskListTable from "./misc/TaskTable";
// import AddTaskModal from "./misc/addTaskModal";
import useControl from "@/hooks/useControl";
// import { Button } from "@/components/ui/button";
// import SuccessfulModal from "@/components/composables/SuccessfulModal";
import Sidebar from "./misc/sidebar";
import { useEffect } from "react";
import { useToken } from "@/hooks/useToken";
import { toast } from "react-toastify";
import { Outlet, useNavigate } from "react-router-dom";

export default function DashboardPage(): JSX.Element {
    // const { state: isOpenAdd, setTrue: onOpenAdd, setFalse: onCloseAdd } = useControl()
    // const { state: isSuccessModalOpen, setTrue: openSuccessModal, setFalse: closeSuccessModal } = useControl()
    const { state: isOpen, setTrue: open, setFalse: close } = useControl()



    const token = useToken();
    const navigate = useNavigate()


    useEffect(() => {
        if (!token) {
            toast.error("Permission denied")
            navigate("/auth/login/staff")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    if (!token) {
        return (<></>)
    } else {
        return (
            <section>
                <Topbar isOpen={isOpen} open={open} close={close} />
                <aside>
                    <Sidebar isOpen={isOpen} open={open} close={close} />
                </aside>
                <main className="h-screen inset-0 overflow-y-auto bg-[#F8FAFC] p-4 lg:ml-[250px] mt-[80px] xl:p-8">
                    <Outlet />
                </main>
            </section>
        );
    }
}
